/*
 * Companies House
 * Used to fetch company info (number, directors etc)
 * Reference: https://developer.companieshouse.gov.uk/api/docs/
 */

import axios from 'axios'

const axiosCompaniesHouseApi = axios.create({
  baseURL: process.env.VUE_APP_COMPANIES_HOUSE_API_URL,
  timeout: 100000,
  auth: {
    username: process.env.VUE_APP_COMPANIES_HOUSE_API_KEY,
    password: '',
  },
})

export default axiosCompaniesHouseApi
